import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  constructor(protected HttpClient: HttpClient) {}
  baseUrl = 'https://dashboard.uncoveregypt.com/api';
}
